export const customStyles = {
  dropdownIndicator: (base) => ({
    ...base,
    color: "var(--black)", 
    border:"none",
    padding:"6px"
  }), 
  indicatorSeparator: (base) => ({
    ...base,
    display: "none"
  }),   
  indicatorsContainer: (base) => ({
    ...base,
    paddingLeft:"5px",
    paddingRight:"5px"

  }),  
  input: (base) => ({
    ...base,
    fontSize:"0.80rem"

  }), 
  placeholder: (base) => ({
    ...base,
    fontSize:"0.80rem"

  }), 
  option: (provided, state) => ({
    ...provided,
    borderBottom: "1px dotted pink",
    color: "var(--black)",
    backgroundColor: state.isSelected ? "var(--strong-blue)" : "white",

    padding: 10,
  }),
  control: (styles,{isDisabled}) => ({
    // none of react-select's styles are passed to <Control />
    border: "var(--black) solid 1px",
    borderRadius: "0.375rem",
    display: "flex",
    padding: "0rem 0.75rem",
    paddingRight:"0",
    backgroundColor: isDisabled ? '#e9ecef' : 'white'
  }),
  singleValue: (styles, {isDisabled}) => ({
    ...styles,
    color:"var(--black)",
    fontSize:"0.8rem !important"
  })
};

